<template>
    <div>
        <div class="simulador_passo_consorcio">
            <h2>Como quer simular?</h2>
            <div class="form-row como_quer_calcular">
                <div class="col-lg-8 offset-lg-2">
                    <div
                        class="btn-group seletor"
                        role="group"
                        aria-label="Como quer calcular?"
                    >
                        <button
                            type="button"
                            class="btn"
                            :class="{
                                tipo_selecionado:
                                    dados_consorcio.tipo_calculo == 'credito'
                            }"
                            @click="dados_consorcio.tipo_calculo = 'credito'"
                        >
                            Valor<br />
                            do<br />
                            crédito
                        </button>
                        <button
                            type="button"
                            class="btn"
                            :class="{
                                tipo_selecionado:
                                    dados_consorcio.tipo_calculo == 'parcela'
                            }"
                            @click="dados_consorcio.tipo_calculo = 'parcela'"
                        >
                            Valor<br />
                            da<br />
                            parcela
                        </button>
                    </div>
                </div>
            </div>
            <h2 v-if="dados_consorcio.tipo_calculo == 'parcela'">
                Qual o valor da parcela?
            </h2>
            <h2 v-if="dados_consorcio.tipo_calculo == 'credito'">
                Qual o valor do crédito?
            </h2>
            <span class="valor_selecionado">{{
                dados_consorcio.range_valor | valor
            }}</span>
            <div class="center">
                <p>
                    Entre {{ dados_consorcio.range_min | valor }} e
                    {{ dados_consorcio.range_max | valor }}
                </p>
            </div>
            <div class="form-row">
                <div class="col-lg-8 offset-lg-2">
                    <input
                        type="range"
                        class="custom-range"
                        :min="dados_consorcio.range_min"
                        :max="dados_consorcio.range_max"
                        step="0.01"
                        v-model="dados_consorcio.range_valor"
                        id="customRange2"
                    />
                </div>
            </div>
        </div>
        <div class="simulador_passo_pessoais">
            <form>
                <div class="row">
                    <div
                        class="
              col-lg-8
              offset-lg-2
              col-md-10
              offset-md-1
              col-sm-12 col-xs-12
            "
                    >
                        <div class="input-group">
                            <label>Seu nome:</label>
                            <input
                                type="text"
                                v-model="form.nome"
                                class="form-control"
                            />
                            <small class="error_message">{{
                                erros.nome
                            }}</small>
                        </div>
                        <div class="input-group">
                            <label>Seu melhor email:</label>
                            <input
                                type="email"
                                v-model="form.email"
                                class="form-control"
                            />
                            <small class="error_message">{{
                                erros.email
                            }}</small>
                        </div>
                        <div class="form-row">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="input-group">
                                    <label>Seu telefone com DDD:</label>
                                    <input
                                        type="text"
                                        v-model="form.telefone"
                                        class="form-control"
                                        v-mask="'(##) #####-####'"
                                    />
                                    <small class="error_message">{{
                                        erros.telefone
                                    }}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div class="form-row">
                <div class="btn_proximo">
                    <button class="btn btn-danger" @click="proximo_passo">
                        Ver oportunidades
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dados_consorcio: {
                tipo_consorcio: "imovel",
                tipo_calculo: "credito",
                range_valor: 0,
                range_min: 0,
                range_max: 1000
            },
            limites: {},
            form: {
                nome: "",
                email: "",
                telefone: "",
                cep: ""
            },
            erros: {
                nome: "",
                email: "",
                telefone: "",
                cep: ""
            }
        };
    },
    methods: {
        proximo_passo() {
            if (!this.validar()) return;

            this.$emit("proximo", {
                consorcio: this.dados_consorcio,
                dadosLead: this.form
            });
        },
        valores_limite() {
            axios.get("/api/apifront/valoreslimite").then(data => {
                this.limites = data.data;
                this.verificar_limites();
            });
        },
        verificar_limites() {
            var tipo = "imoveis";

            if (this.dados_consorcio.tipo_calculo == "parcela") {
                this.dados_consorcio.range_min = this.limites[tipo].parcela_min;
                this.dados_consorcio.range_max = this.limites[tipo].parcela_max;
                this.dados_consorcio.range_valor = this.dados_consorcio.range_min;
            } else {
                this.dados_consorcio.range_min = this.limites[tipo].credito_min;
                this.dados_consorcio.range_max = this.limites[tipo].credito_max;
                this.dados_consorcio.range_valor = this.dados_consorcio.range_min;
            }
        },
        validar() {
            this.erros = {};

            if (this.form.nome.trim() == "")
                this.erros.nome = "Informe seu nome";
            if (this.form.email.trim() == "")
                this.erros.email = "Informe seu melhor e-mail";
            if (!this.validateEmail(this.form.email))
                this.erros.email = "Informe um e-mail válido";
            if (this.form.telefone.trim() == "")
                this.erros.telefone = "Informe seu telefone para contato";
            if (this.form.telefone.trim().length < 13)
                this.erros.telefone = "Informe um telefone válido";

            if (Object.entries(this.erros).length == 0) return true;

            return false;
        },
        validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
    },
    computed: {
        preenchido: function() {
            if (
                this.form.nome.trim() != "" &&
                this.form.email.trim() != "" &&
                this.form.telefone.trim() != "" &&
                this.form.cep.trim() != ""
            ) {
                return true;
            }
            return false;
        }
    },
    watch: {
        "dados_consorcio.tipo_consorcio"(newV, oldV) {
            this.verificar_limites();
        },
        "dados_consorcio.tipo_calculo"(newV, oldV) {
            this.verificar_limites();
        },
        preenchido: function(newF, OldF) {
            if (newF == true) this.$emit("can-continue", { value: true });
        }
    },
    mounted() {
        this.valores_limite();
        if (this.preenchido) this.$emit("can-continue", { value: true });
    }
};
</script>
<style scoped>
.simulador_passo_pessoais{
    margin-top: 50px;
}
</style>
